import {
  ContornoDocumento,
  PasoEscaner,
  PuntosContorno,
} from './escaner.models';

/* Dimensiones del PDF (A4) */
export const A4_WIDTH_PX = 595;
export const A4_HEIGHT_PX = 842;
export const A4_MARGIN_PX = 20;

/* Títulos de los pasos del escáner */
export const TITULOS_PASO_ESCANER: Record<PasoEscaner, string> = {
  [PasoEscaner.FUENTE]: '¿Cómo quieres importar el archivo?',
  [PasoEscaner.USAR_CAMARA]: 'Tomar Foto',
  [PasoEscaner.RECORTE]: 'Recortar Imagen',
  [PasoEscaner.CONFIRMAR]: 'Confirmar Imagen',
  [PasoEscaner.AGREGAR]: 'Agregar Páginas',
  [PasoEscaner.PDF]: 'Confirmar PDF Generado',
};

/**
 * Convierte un contorno de documento a puntos de contorno.
 * @param {ContornoDocumento | undefined} contorno - Contorno de documento.
 * @returns {PuntosContorno} Puntos de contorno.
 * @author Juan Corral
 */
export function contornoAPuntos(
  contorno: ContornoDocumento | undefined,
): PuntosContorno {
  if (
    !contorno ||
    !contorno.topLeftCorner ||
    !contorno.topRightCorner ||
    !contorno.bottomRightCorner ||
    !contorno.bottomLeftCorner ||
    contorno.topLeftCorner.x >= contorno.topRightCorner.x ||
    contorno.topLeftCorner.y >= contorno.bottomLeftCorner.y ||
    contorno.topRightCorner.y >= contorno.bottomRightCorner.y ||
    contorno.bottomLeftCorner.x >= contorno.bottomRightCorner.x
  ) {
    return [
      { x: 50, y: 50 },
      { x: 600, y: 50 },
      { x: 600, y: 600 },
      { x: 50, y: 600 },
    ];
  }

  return [
    { x: contorno.topLeftCorner.x, y: contorno.topLeftCorner.y },
    { x: contorno.topRightCorner.x, y: contorno.topRightCorner.y },
    { x: contorno.bottomRightCorner.x, y: contorno.bottomRightCorner.y },
    { x: contorno.bottomLeftCorner.x, y: contorno.bottomLeftCorner.y },
  ];
}

/**
 * Convierte unos puntos de contorno a un contorno de documento.
 * @param {PuntosContorno} puntos - Puntos de contorno.
 * @returns {ContornoDocumento} Contorno de documento.
 * @author Juan Corral
 */
export function puntosAContorno(puntos: PuntosContorno): ContornoDocumento {
  return {
    topLeftCorner: { x: puntos[0].x, y: puntos[0].y },
    topRightCorner: { x: puntos[1].x, y: puntos[1].y },
    bottomRightCorner: { x: puntos[2].x, y: puntos[2].y },
    bottomLeftCorner: { x: puntos[3].x, y: puntos[3].y },
  };
}
